import request from '@/utils/request';
// 库存台账列表
export const getShellRecordList = (params: any) =>    
  request({
    url: 'CompanyShell/shellRecordList',
    method: 'GET',
    params
  });

